import React from "react";
import { Box, Typography } from "@mui/material";
import { PersonOutlined } from "@mui/icons-material";

const IntervenantCard = ({ intervenant }) => {
  const [imageError, setImageError] = React.useState(false);

  return (
    <a 
      href={`https://www.inexplore.com/soutien/${intervenant.url}`} 
      target="_blank"
    ><Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
      }}
    >
      
      <Box
        sx={{
          display: "flex",
          width: "80px",
          height: "80px",
          borderRadius: "50%",
          alignItems: "center",
          justifyContent: "center",
          background: "lightgrey",
          overflow: "hidden",
        }}
      >
        {imageError === false ? (
          <img
            src={`https://medias.inrees.com/img/soutien/${intervenant.id}.jpg`}
            alt={"image de l'intervenant"}
            style={{
              width: "100%",
              objectFit: "cover",
            }}
            onError={(e) => {
              //setImageError(true);
            }}
          />
        ) : (
          <PersonOutlined
            sx={{
              width: "30px",
              height: "30px",
            }}
          />
        )}
      </Box>
      <Typography
        sx={{
          marginTop: 0.5,
          fontSize: "16px",
          fontWeight: "bold",
          color: (theme) => theme.palette.blackPro,
          "&:hover": {
            color: (theme) => theme.palette.primary.main
          }
        }}
      >
        {`${intervenant.prenom} ${intervenant.nom}`}
      </Typography>
      <Typography
        sx={{
          fontSize: "16px",
          color: (theme) => theme.palette.blackPro,
          opacity: 0.5,
          "&:hover": {
            color: (theme) => theme.palette.primary.main
          }
        }}
      >
        {`${intervenant.profession}`}
      </Typography>
    </Box></a>
  );
};

export default IntervenantCard;
